export default __webpack_public_path__ + "static/media/loading.6446f0ac.gif";